<template>
  <div class="agreement-box clearfix">
    <div
      class="agreement-checkbox"
      :class="[value ? 'agreement-checkbox-active' : 'agreement-checkbox-init']"
      @click="handleClick"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.agreement`,
      }"
    >
      <div class="agreement-checkbox-right" v-if="value"></div>
    </div>
    <div class="agreement-text">
      <span>{{ agreeReadPreText }}</span>
      <a
        :href="privacyHref"
        class="privacy"
        target="_blank"
        v-track="{ type: 'click', name: 'form.privacy_details' }"
      >
        {{ $t('login.register.privacyPolicyName') }}
      </a>
    </div>
  </div>
</template>

<script>
import { getBusinessType } from '@/constant'

export default {
  data() {
    return {}
  },
  props: {
    value: Boolean,
  },
  computed: {
    privacyHref() {
      const address = process.env.NODE_ENV == 'production' ? 'online' : 'top'

      return `https://www.gotin.${address}/cn/aiaprivacy/`
    },
    agreeReadPreText() {
      return getBusinessType().agreeReadPreText
    },
  },
  methods: {
    handleClick() {
      this.$emit('input', !this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.agreement-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .agreement-checkbox {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    .agreement-checkbox-right {
      width: 100%;
      height: 100%;
      border: none;
      background: transparent center center url(/img/right.e83b9945.svg)
        no-repeat;
      vertical-align: top;
      left: 0;
      top: 0;
    }
  }
  .agreement-checkbox-active {
    background-color: #f0386c;
    border-color: #f0386c;
  }
  .agreement-checkbox-init {
    background-color: rgba(255, 255, 255, 0.6);
    border-color: rgba(255, 255, 255, 0.6);
  }
  .agreement-text {
    margin-left: 5.5px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
  }
  .privacy {
    color: #f63b6d;
    text-decoration: none;
  }
}
</style>
